import { useState } from "react";
import API from "../../services/API";
import Layout from '../Frames/Layout'
import Grid from "../Tools/Grid";
import { Link } from "react-router-dom";
import Avatar from "../Tools/Avatar";
import CheckIcon from '@mui/icons-material/Check';
import UncheckIcon from '@mui/icons-material/Close';
import { Link as A } from "@mui/material";
import moment from "moment/moment";
import EnrollmentCashing from "./EnrollmentCashing";
import { useQuery } from "react-query";
import Range from "../Inputs/Range";
import Loader from "../Tools/Loader";

export default function Enrollments(){
    
    const columns = [
        {
            field: 'createdAt',
            headerName: 'Date',
            type: 'date',
            width: 90,
            aggregable: false,
            valueGetter: i => moment(i.row.createdAt).toDate(),
            renderCell: i => !i.rowNode.isAutoGenerated &&
                moment(i.value).format('DD/MM/YYYY à HH:mm')
        },
        {
            field: 'course',
            headerName: 'Formation',
            width: 400,
            aggregable: false,
            valueGetter: i => i.row.course?.title
        },
        {
            field: 'pi',
            headerName: 'P.I.',
            width: 50,
            type: 'boolean',
            aggregable: false,
            valueGetter: p => p.row.pi,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                (p.row.pi ? 
                    <CheckIcon color='primary' size='small'/> : 
                    <UncheckIcon color='error' size='small'/>)
        },
        {
            field: 'type',
            headerName: 'Type',
            width: 190,
            aggregable: false,
            valueGetter: i => i.row.type?.title
        },
        {
            field: 'amount',
            headerName: 'Montant €',
            type: 'number',
            width: 100,
            valueGetter: i => i.row.amount || 0,
        },
        {
            field: 'avatar',
            headerName: '',
            width: 60,
            aggregable: false,
            valueGetter: i => i.row.user?.id,
            renderCell: i => !i.rowNode.isAutoGenerated &&
                <Link to={`/crm/persons/${i.row.user?.id}`}>
                    <Avatar 
                        initials={i.row.user?.initials} 
                        color={i.row.category?.color || 'grey'} 
                        size={36} 
                    />
                </Link>,
        },
        {
            field: 'user',
            headerName: 'Nom',
            width: 200,
            aggregable: false,
            valueGetter: i => i.row.user?.name
        },
        {
            field: 'email',
            headerName: 'Email',
            width: 210,
            aggregable: false,
            valueGetter: i => i.row.user?.email,
            renderCell: i => 
                <A href={`mailto:${i.value}`}>
                    {i.value}
                </A>
        },
        {
            field: 'phone',
            headerName: 'Tél',
            width: 120,
            aggregable: false,
            valueGetter: i => i.row.user?.phone,
            renderCell: i => i.value &&
                <A href={`tel:${i.value}`}>
                    {i.value}
                </A>
        },
        {
            field: 'category',
            headerName: 'Filière',
            width: 150,
            aggregable: false,
            valueGetter: i => i.row.category?.title
        },
        {
            field: 'completion',
            headerName: 'Complétion',
            type: 'number',
            width: 100,
            valueGetter: i => i.row.completion || 0,
        },
        {
            field: 'duration',
            headerName: 'Durée',
            type: 'number',
            width: 60,
            valueGetter: i => i.row.hours || 0,
            renderCell: i => !i.rowNode.isAutoGenerated  &&
                i.value.toLocaleString() + 'h'
        },
        {
            field: 'dpc',
            headerName: 'DPC',
            width: 350,
            aggregable: false,
            valueGetter: i => i.row.dpc?.title
        },
        {
            field: 'origin',
            headerName: 'Provenance',
            width: 100,
            aggregable: false,
            valueGetter: i => i.row.origin?.title
        },
        {
            field: 'wonBy',
            headerName: 'Commercial',
            width: 150,
            aggregable: false,
            valueGetter: i => i.row.wonBy?.name
        },
        {
            field: 'cashedAt',
            headerName: 'Encaissé le',
            width: 150,
            aggregable: false,
            valueGetter: i => i.row.cashedAt,
            renderCell: i => !i.rowNode.isAutoGenerated &&
                <EnrollmentCashing enrollment={i.row} onChange={handleChange} />
        },
    ];

    const [items, setItems] = useState([]);
    const [start, setStart] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [end, setEnd] = useState(moment().endOf('month').format('YYYY-MM-DD'));

    const { refetch, isLoading } = useQuery({
        queryKey: ['enrollments', 'between', start, end],
        queryFn: async () => {
            const response = await API.get(`/crm/enrollments/between?start=${start}&end=${end}`);
            setItems(response.data);
            return response.data;
        }
    });

    const handleDateChange = dates => {
        setStart(dates.start);
        setEnd(dates.end);
        setItems([]);
    }

    const handleChange = item => {
        let copy = [...items].filter(i => i.id !== item.id)
        copy.push(item)
        setItems(copy)
        refetch();
    }

    return <Layout tab='enrollments' menu='crm' title='Inscriptions'>

        <Range start={start} end={end} onChange={handleDateChange} sx={{ mb: 1 }} />
        
        {isLoading && <Loader />}

        {!isLoading && <Grid 
            id='enrollmentsGrid'
            columns={columns}
            rows={items}
            toolbar
            aggregate={{amount: 'sum', completion: 'avg'}}
            loading={isLoading}
        />}

    </Layout>

}


